import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { themeColors } from '../../styles/themeColors';

export default makeStyles((theme: Theme) => ({
  langLabel: {
    color: themeColors.textComplimentary,
    fontWeight: 'bold',
  },
}));
